import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {DashboardQueryResponce} from './_models'



const API_URL = process.env.REACT_APP_THEME_API_URL
const DASHBOARD_URL = `${API_URL}/dashboard`

const getdashborddata = (query: string): Promise<DashboardQueryResponce> => {
    return axios
      .get(`${DASHBOARD_URL}?${query}`)
      .then((d: AxiosResponse<DashboardQueryResponce>) => {
        console.log("API Response:", d.data);
      return d.data
      })
      
  }
  
  export {getdashborddata}